module.exports = __webpack_public_path__ + "media/customizations/samlarc/logo-5f5f8732d9daacfd725e47f81aac772f.png";